import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchDeleteCompany } from "./companyAPI";
import swal from 'sweetalert';
export interface DeleteCompanyState {
  deleteCompany: Array<any>;
  status: "idle" | "loading" | "failed";
}

const initialState: DeleteCompanyState = {
    deleteCompany: [],
  status: "idle",
};

export const GetDeleteCompany = createAsyncThunk(
  "DeleteCompany/fetchDeleteCompany",
  async (data:any) => {
    const response = await fetchDeleteCompany(data);
    return response;
  }
);

export const DeleteCompanySlice = createSlice({
  name: "DeleteCompany",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetDeleteCompany.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetDeleteCompany.rejected, (state) => {
        state.status = "failed";
        swal("Something went wrong!",  "error");
      })
      .addCase(GetDeleteCompany.fulfilled, (state, action) => {
        state.status = "idle";
        state.deleteCompany = action.payload;
        swal("Record delete success!",  "success");
      });
  },
});

export const {} = DeleteCompanySlice.actions;

export const selectDeleteCompany = (state: RootState) => {
  return state.DeleteCompany.deleteCompany;
};

export default DeleteCompanySlice.reducer;
